import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import { Map } from 'immutable';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { withStyles, Grid } from '@material-ui/core';
import {
    FHEContainerForm,
    FHEContainerScroll,
    FHETitle,
    FHETextField,
    FormEditButton,
    FHECheckbox,
    FHEReactSelect,
    FormSaveButton,
    FHEButton
} from 'data/components';
import { Toastr, tools } from 'data/common';
import { SvgCraftsman } from 'data/common/iconsvg';
import memoizeOne from 'memoize-one';

class FormInstaller extends PureComponent {
    static propTypes = {
        profile: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired,
        match: PropTypes.object.isRequired,
        resetPassword: PropTypes.func,
        renderOtherChildren: PropTypes.func,
        installer: PropTypes.object.isRequired,
        sendDataFunc: PropTypes.func.isRequired,
        type: PropTypes.string.isRequired
    };

    static defaultProps = {
        resetPassword: null,
        renderOtherChildren: null
    };

    constructor(props) {
        super(props);
        const { type } = props;

        this.state = {
            passwordReseting: false,
            provisionningBox: false,
            formDisabled: type === 'update',
            installerForm: this.getDataForm(),
            textInput_error: {},
            sendLoading: false
        };
        this.roles = [
            {
                value: 'installer',
                label: Translator.translate('generic.installer.role.installer')
            },
            { value: 'admin', label: Translator.translate('generic.installer.role.admin') }
        ];
    }

    getDataForm = () => {
        const { type, installer } = this.props;
        return {
            username: type === 'update' ? installer.get('username') : null,
            firstname: type === 'update' ? installer.get('firstname') : null,
            lastname: type === 'update' ? installer.get('lastname') : null,
            company: type === 'update' ? installer.get('company') : null,
            phone: type === 'update' ? installer.get('phone') : null,
            email: type === 'update' ? installer.get('email') : null,
            role: type === 'update' ? installer.get('role') : null,
            address: type === 'update' ? installer.get('address') : null,
            postalCode: type === 'update' ? installer.get('postalCode') : null,
            city: type === 'update' ? installer.get('city') : null,
            isActive: type === 'update' ? !!installer.get('isActive') : null
        };
    };

    loadInputs = () => {
        this.setState({
            formDisabled: true,
            sendLoading: false,
            installerForm: this.getDataForm()
        });
    };

    handleEdit = () => {
        const { formDisabled } = this.state;

        if (!formDisabled) this.loadInputs();
        this.setState({
            formDisabled: !formDisabled,
            textInput_error: {}
        });
    };

    handleChange = event => {
        const { installerForm, textInput_error } = this.state;
        let targetValue = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
        const fieldLengthRules = {
            username: 30,
            firstname: 255,
            lastname: 255,
            company: 255,
            phone: 10,
            email: 255,
            address: 500,
            postalCode: 10,
            city: 255
        };

        let newTextInput_error = this.removeKey(textInput_error, event.target.name);

        let maxLength = fieldLengthRules[event.target.name];
        if (maxLength && targetValue.length > maxLength) targetValue = installerForm[event.target.name];
        this.setState({
            installerForm: { ...installerForm, [event.target.name]: targetValue },
            textInput_error: newTextInput_error
        });
    };

    removeKey = (myObj, deleteKey) => {
        return Object.assign(
            {},
            ...Object.entries(myObj)
                .filter(([k]) => k !== deleteKey)
                .map(([k, v]) => ({ [k]: v }))
        );
    };

    handleFormError = (fields, message) => {
        let res = {};
        Object.keys(fields).map(field => {
            fields[field].forEach(error => {
                if (res[field] === undefined) res[field] = [];

                res[field].push(
                    <p key={error} className="mb-1">
                        {Translator.translate(`general.fields.error.${error}`)}
                    </p>
                );
            });
        });

        this.setState({
            textInput_error: res
        });

        return Toastr.error(message);
    };

    formatForm = () => {
        const { installerForm } = this.state;
        const { type } = this.props;
        let form = installerForm;
        Object.keys(form).forEach(key => {
            if (form[key] === '') {
                form[key] = null;
            }
            if (type === 'add' && key === 'isActive') {
                form[key] = 1;
            }
        });
        this.setState({
            installerForm: form
        });
    };

    isEmpty = value => {
        return value === null || /^\s*$/.test(value);
    };

    confirmEdit = () => {
        const { installerForm } = this.state;
        const { sendDataFunc, match } = this.props;

        this.formatForm();

        if (this.validateForm(installerForm)) {
            this.setState({
                sendLoading: true,
                formDisabled: true
            });
            return sendDataFunc(match.params.installerId, installerForm)
                .then(() => {
                    Toastr.success(Translator.translate('generic.installer.actions.editInstallerSuccess', installerForm.username));
                    this.loadInputs();
                    this.setState({
                        formDisabled: true,
                        provisionningBox: false,
                        sendLoading: false
                    });
                })
                .catch(error => {
                    this.setState({
                        sendLoading: false,
                        formDisabled: false
                    });
                    Toastr.error(
                        Translator.translateWithFallback(
                            `api.message.${error.message}`,
                            'generic.installer.actions.editInstallerError',
                            installerForm.username
                        )
                    );
                    if (error.validation && error.validation.errors) {
                        return this.handleFormError(
                            error.validation.errors,
                            Translator.translate('generic.installer.actions.editInstallerError', installerForm.username)
                        );
                    }
                });
        }
    };

    askResetPassword = e => {
        const { installerForm } = this.state;
        e.preventDefault();
        Toastr.confirm(
            Translator.translate('generic.installer.actions.confirmResetPassword', installerForm.username),
            Translator.translate('generic.installer.actions.resetPasswordTitle'),
            {
                onYes: this.resetPassword
            }
        );
    };

    resetPassword = () => {
        const { match, resetPassword } = this.props;
        const { installerForm } = this.state;

        this.setState(
            {
                passwordReseting: true
            },
            () => {
                return resetPassword(match.params.installerId, installerForm)
                    .then(() => {
                        Toastr.success(Translator.translate('generic.installer.actions.resetPasswordSuccess', installerForm.username));
                    })
                    .catch(() => {
                        Toastr.error(Translator.translate('generic.installer.actions.resetPasswordError', installerForm.username));
                    })
                    .finally(() => {
                        this.setState({
                            passwordReseting: false
                        });
                    });
            }
        );
    };

    saveInstaller = () => {
        const { installerForm } = this.state;
        const { sendDataFunc, history, profile } = this.props;
        this.formatForm();

        if (this.validateForm(installerForm)) {
            this.setState({
                formDisabled: true,
                sendLoading: true
            });
            return sendDataFunc(installerForm)
                .then(data => {
                    const installer = data.installer;
                    Toastr.success(Translator.translate('generic.installer.actions.addInstallerSuccess', installer.username));
                    if (profile.get('admin') || profile.getIn(['user_rights', history.environment], []).includes('installerDetails'))
                        return history.push(`/${history.environment}/installer/detail/${data.installerId}`);
                    return history.push(`/${history.environment}/installer`);
                })
                .catch(error => {
                    Toastr.error(Translator.translate('generic.installer.actions.addInstallerError', installerForm.username));
                    this.setState({
                        formDisabled: false,
                        sendLoading: false
                    });
                    if (error.validation && error.validation.errors) {
                        return this.handleFormError(
                            error.validation.errors,
                            Translator.translate('generic.installer.actions.addInstallerError', installerForm.username)
                        );
                    }
                });
        }
    };

    validateForm(form) {
        const errors = {};
        const regexTel = RegExp(/^(\+[1-9]{2}\s|0)([1-9])((\s|\.|-)?\d{2}){4}$/);

        if (this.isEmpty(form.username)) {
            errors['username'] = Translator.translate('general.fields.error.any.empty');
        }
        if (this.isEmpty(form.firstname)) {
            errors['firstname'] = Translator.translate('general.fields.error.any.empty');
        }
        if (this.isEmpty(form.lastname)) {
            errors['lastname'] = Translator.translate('general.fields.error.any.empty');
        }
        if (this.isEmpty(form.email)) {
            errors['email'] = Translator.translate('general.fields.error.any.empty');
        }
        if (this.isEmpty(form.phone)) {
            errors['phone'] = Translator.translate('general.fields.error.any.empty');
        }
        if (!this.isEmpty(form.phone) && !regexTel.test(form.phone)) {
            errors['phone'] = Translator.translate('general.fields.error.string.regex.base');
        }
        if (this.isEmpty(form.address)) {
            errors['address'] = Translator.translate('general.fields.error.any.empty');
        }
        if (this.isEmpty(form.postalCode)) {
            errors['postalCode'] = Translator.translate('general.fields.error.any.empty');
        }
        if (this.isEmpty(form.city)) {
            errors['city'] = Translator.translate('general.fields.error.any.empty');
        }
        if (this.isEmpty(form.role)) {
            errors['role'] = Translator.translate('general.fields.error.any.empty');
        }
        if (this.isEmpty(form.company)) {
            errors['company'] = Translator.translate('general.fields.error.any.empty');
        }
        this.setState({
            textInput_error: errors
        });

        return Object.keys(errors).length <= 0;
    }

    getSelectedRole = memoizeOne(role => {
        return this.roles.find(x => x.value === role);
    });

    handleReactSelect = (event, options) => {
        const { installerForm, textInput_error } = this.state;

        const newTextInput_error = tools.removeKey(textInput_error, options.name);

        this.setState({
            installerForm: { ...installerForm, [options.name]: event.value },
            textInput_error: newTextInput_error
        });
    };

    render() {
        const { textInput_error, formDisabled, provisionningBox, sendLoading, installerForm, passwordReseting } = this.state;
        const { profile, type, renderOtherChildren } = this.props;
        const updateInstallerRights = profile.get('admin') || profile.getIn(['user_rights', 'fhe'], []).includes('installerDetailsUpdate');
        const deactivationInstallerRights = profile.get('admin') || profile.getIn(['user_rights', 'fhe'], []).includes('installerDesactivation');
        const resetPasswordRights = profile.get('admin') || profile.getIn(['user_rights', 'fhe'], []).includes('installerResetPassword');

        return (
            <Fragment>
                {type === 'add' ? (
                    <FormSaveButton sendFunc={this.saveInstaller} sendLoading={sendLoading} />
                ) : (
                    <Fragment>
                        <FHETitle title={installerForm.username} Icon={SvgCraftsman} />
                        {updateInstallerRights && (
                            <FormEditButton
                                formDisabled={formDisabled && !provisionningBox}
                                handleEdit={this.handleEdit}
                                confirmEdit={this.confirmEdit}
                                sendLoading={sendLoading}
                            />
                        )}
                    </Fragment>
                )}
                <FHEContainerScroll>
                    <FHEContainerForm>
                        <Grid container spacing={3}>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHETextField
                                    disabled={formDisabled}
                                    id="username"
                                    value={installerForm.username}
                                    error={textInput_error.username}
                                    label={Translator.translate('general.table.column.username')}
                                    name="username"
                                    onChange={this.handleChange}
                                />
                            </Grid>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHETextField
                                    disabled={formDisabled}
                                    id="firstname"
                                    value={installerForm.firstname}
                                    error={textInput_error.firstname}
                                    label={Translator.translate('general.table.column.firstname')}
                                    name="firstname"
                                    onChange={this.handleChange}
                                />
                            </Grid>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHETextField
                                    disabled={formDisabled}
                                    id="lastname"
                                    value={installerForm.lastname}
                                    error={textInput_error.lastname}
                                    label={Translator.translate('general.table.column.lastname')}
                                    name="lastname"
                                    onChange={this.handleChange}
                                />
                            </Grid>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHETextField
                                    disabled={formDisabled}
                                    id="company"
                                    value={installerForm.company}
                                    error={textInput_error.company}
                                    label={Translator.translate('general.table.column.company')}
                                    name="company"
                                    onChange={this.handleChange}
                                />
                            </Grid>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHETextField
                                    disabled={formDisabled}
                                    id="email"
                                    value={installerForm.email}
                                    error={textInput_error.email}
                                    label={Translator.translate('general.table.column.email')}
                                    name="email"
                                    onChange={this.handleChange}
                                />
                            </Grid>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHETextField
                                    disabled={formDisabled}
                                    id="phone"
                                    value={installerForm.phone}
                                    error={textInput_error.phone}
                                    label={Translator.translate('general.table.column.phone')}
                                    name="phone"
                                    onChange={this.handleChange}
                                />
                            </Grid>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHETextField
                                    disabled={formDisabled}
                                    id="phone"
                                    value={installerForm.address}
                                    error={textInput_error.address}
                                    label={Translator.translate('general.table.column.address')}
                                    name="address"
                                    onChange={this.handleChange}
                                />
                            </Grid>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHETextField
                                    disabled={formDisabled}
                                    id="phone"
                                    value={installerForm.postalCode}
                                    error={textInput_error.postalCode}
                                    label={Translator.translate('general.table.column.postalCode')}
                                    name="postalCode"
                                    onChange={this.handleChange}
                                />
                            </Grid>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHETextField
                                    disabled={formDisabled}
                                    id="phone"
                                    value={installerForm.city}
                                    error={textInput_error.city}
                                    label={Translator.translate('general.table.column.city')}
                                    name="city"
                                    onChange={this.handleChange}
                                />
                            </Grid>
                            {type === 'update' && (
                                <Grid container item sm={12} md={6} lg={4}>
                                    <FHECheckbox
                                        disabled={!deactivationInstallerRights || formDisabled}
                                        checked={!!installerForm.isActive}
                                        label={Translator.translate('general.table.column.isActive')}
                                        value="isActive"
                                        onChange={this.handleChange}
                                    />
                                </Grid>
                            )}
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHEReactSelect
                                    name="role"
                                    label={Translator.translate('general.table.column.role')}
                                    onChange={this.handleReactSelect}
                                    value={this.getSelectedRole(installerForm.role)}
                                    choices={this.roles}
                                    disabled={formDisabled}
                                />
                            </Grid>

                            {type === 'update' && resetPasswordRights && (
                                <Grid container item sm={12} md={6} lg={4}>
                                    <FHEButton
                                        content={Translator.translate('generic.user.actions.resetPassword')}
                                        clickFunction={this.askResetPassword}
                                        loading={passwordReseting}
                                    />
                                </Grid>
                            )}
                        </Grid>
                    </FHEContainerForm>
                    {renderOtherChildren && renderOtherChildren()}
                </FHEContainerScroll>
            </Fragment>
        );
    }
}

function mapStateToProps(state, props) {
    const installer = state.environments.fhe.data.Installers.getIn(['list', props.match.params.installerId], new Map());

    return {
        profile: state.data.user,
        installer
    };
}

const styles = theme => ({
    loadingContainer: {
        textAlign: 'center'
    },
    checkIcon: {
        color: theme.palette.success.main
    }
});

export default withRouter(connect(mapStateToProps)(withStyles(styles, { withTheme: true })(FormInstaller)));



// WEBPACK FOOTER //
// ./environments/fhe/scenes/Installer/Form/FormInstaller.js